"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmojiPickerContent = EmojiPickerContent;
var _react = _interopRequireWildcard(require("react"));
var _cn = require("@udecode/cn");
var _plateEmoji = require("@udecode/plate-emoji");
var _jsxRuntime = require("react/jsx-runtime");
var Button = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var emoji = _ref.emoji,
    index = _ref.index,
    onMouseOver = _ref.onMouseOver,
    onSelect = _ref.onSelect;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
    "aria-label": emoji.skins[0].native,
    className: "group relative flex size-9 cursor-pointer items-center justify-center border-none bg-transparent text-2xl leading-none",
    "data-index": index,
    onClick: function onClick() {
      return onSelect(emoji);
    },
    onMouseEnter: function onMouseEnter() {
      return onMouseOver(emoji);
    },
    onMouseLeave: function onMouseLeave() {
      return onMouseOver();
    },
    tabIndex: -1,
    type: "button",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      "aria-hidden": "true",
      className: "absolute inset-0 rounded-full opacity-0 group-hover:opacity-100"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      "data-emoji-set": "native",
      style: {
        position: 'relative'
      },
      children: emoji.skins[0].native
    })]
  });
});
Button.displayName = 'Button';
var RowOfButtons = /*#__PURE__*/(0, _react.memo)(function (_ref2) {
  var emojiLibrary = _ref2.emojiLibrary,
    onMouseOver = _ref2.onMouseOver,
    onSelectEmoji = _ref2.onSelectEmoji,
    row = _ref2.row;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "flex",
    "data-index": row.id,
    children: row.elements.map(function (emojiId, index) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(Button, {
        emoji: emojiLibrary.getEmoji(emojiId),
        index: index,
        onMouseOver: onMouseOver,
        onSelect: onSelectEmoji
      }, emojiId);
    })
  }, row.id);
});
RowOfButtons.displayName = 'RowOfButtons';
function EmojiPickerContent(_ref3) {
  var emojiLibrary = _ref3.emojiLibrary,
    i18n = _ref3.i18n,
    _ref3$isSearching = _ref3.isSearching,
    isSearching = _ref3$isSearching === void 0 ? false : _ref3$isSearching,
    onMouseOver = _ref3.onMouseOver,
    onSelectEmoji = _ref3.onSelectEmoji,
    refs = _ref3.refs,
    searchResult = _ref3.searchResult,
    _ref3$settings = _ref3.settings,
    settings = _ref3$settings === void 0 ? _plateEmoji.EmojiSettings : _ref3$settings,
    visibleCategories = _ref3.visibleCategories;
  var getRowWidth = settings.perLine.value * settings.buttonSize.value;
  var isCategoryVisible = (0, _react.useCallback)(function (categoryId) {
    return visibleCategories.has(categoryId) ? visibleCategories.get(categoryId) : false;
  }, [visibleCategories]);
  var EmojiList = (0, _react.useCallback)(function () {
    return emojiLibrary.getGrid().sections().map(function (_ref4) {
      var categoryId = _ref4.id;
      var section = emojiLibrary.getGrid().section(categoryId);
      var buttonSize = settings.buttonSize;
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        "data-id": categoryId,
        ref: section.root,
        style: {
          width: getRowWidth
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "sticky -top-px z-[1] bg-card/90 p-1 py-2 text-sm font-semibold backdrop-blur-sm",
          children: i18n.categories[categoryId]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "relative flex flex-wrap",
          style: {
            height: section.getRows().length * buttonSize.value
          },
          children: isCategoryVisible(categoryId) && section.getRows().map(function (row) {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(RowOfButtons, {
              emojiLibrary: emojiLibrary,
              onMouseOver: onMouseOver,
              onSelectEmoji: onSelectEmoji,
              row: row
            }, row.id);
          })
        })]
      }, categoryId);
    });
  }, [emojiLibrary, getRowWidth, i18n.categories, isCategoryVisible, onSelectEmoji, onMouseOver, settings]);
  var SearchList = (0, _react.useCallback)(function () {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      "data-id": "search",
      style: {
        width: getRowWidth
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "sticky -top-px z-[1] bg-card/90 p-1 py-2 font-semibold backdrop-blur-sm",
        children: i18n.searchResult
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "relative flex flex-wrap",
        children: searchResult.map(function (emoji, index) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(Button, {
            emoji: emojiLibrary.getEmoji(emoji.id),
            index: index,
            onMouseOver: onMouseOver,
            onSelect: onSelectEmoji
          }, emoji.id);
        })
      })]
    });
  }, [emojiLibrary, getRowWidth, i18n.searchResult, searchResult, onSelectEmoji, onMouseOver]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: (0, _cn.cn)('h-full min-h-[50%] overflow-y-auto overflow-x-hidden px-3', '[&::-webkit-scrollbar]:w-4', '[&::-webkit-scrollbar-button]:hidden [&::-webkit-scrollbar-button]:size-0', ':hover:[&::-webkit-scrollbar-thumb]:bg-[#f3f4f6]', '[&::-webkit-scrollbar-thumb]:min-h-[65px] [&::-webkit-scrollbar-thumb]:rounded-2xl [&::-webkit-scrollbar-thumb]:border-4 [&::-webkit-scrollbar-thumb]:border-white', '[&::-webkit-scrollbar-track]:border-0'),
    "data-id": "scroll",
    ref: refs.current.contentRoot,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "h-full",
      ref: refs.current.content,
      children: isSearching ? SearchList() : EmojiList()
    })
  });
}